export default __webpack_public_path__ + "static/media/icon-shopping-cart.d55ae5fa.svg";